export const MINIAPP_SHARE_URL =
  "https://farcaster.xyz/miniapps/Pev_FdNhl2dG/warplet-mutants";

export const OPENSEA_URL =
  "https://opensea.io/collection/warplet-mutants-aftershock";

export const PROFILE_URL = "https://farcaster.xyz/warpletmutants.eth";
